import * as Yup from 'yup';

const validationSchema = () => {
  return Yup.object({
    date: Yup.string().required('validation/required'),
    time: Yup.string().required('validation/required'),
    servings: Yup.number()
      .min(0.1, 'tracker.servings.validation.description')
      .max(30, 'tracker.servings.validation.description')
      .required('validation/required'),
  });
};

export default validationSchema;
